import { Container } from "@mui/material";
import React from "react";

import { Outlet } from "react-router-dom";

function UserHome() {
    return (
        <Container maxWidth={"xl"} className={"atsGlobalContainer"}>
            <Outlet />
        </Container>
    );
}

export default UserHome;
